import {addEventHandlers} from "./drag-and-drop-event-handlers";

export const createDragAndDropStoreEnhancer = (options) =>
  (createStore) =>
    (...args) =>
      addEventHandlers(createStore(...args), options);
